import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { FormLabel } from '@/components/v4';
import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import TagInput from 'components/v4/ChipInput/TagInput';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { useChipCodesField } from '../useChipCodesField';
import {
    NUMERIC_PATTERN,
    focusWithinStyles,
    LABEL_TO_INPUT_GAP,
} from '../constants';

// Shared chip-input field for the National Codes / Multi-National Codes fields.
const CountryCodesField = ({
    name,
    label,
    placeholder,
    exampleText,
    values,
    setFieldValue,
    isDisabled,
    stackPaddingTop = 0,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const codes = values[name] || [];
    const { darkMode } = useSelector((state) => state.settings);
    const {
        input,
        error,
        handleChange,
        handleKeyDown,
        handlePaste,
        handleCloseClick,
    } = useChipCodesField({
        label,
        codes,
        onChange: (newCodes) => setFieldValue(name, newCodes),
        pattern: NUMERIC_PATTERN,
    });

    return (
        <FormControl
            isInvalid={error.isError}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                align="center"
                sx={{
                    ...stackStyling(),
                    ...formInputStyles,
                    pt: stackPaddingTop,
                }}>
                <FormLabel sx={formLabelStyling(darkMode, true)}>
                    {label}
                </FormLabel>
                <TagInput
                    flex={1}
                    chips={codes}
                    isDisabled={isDisabled}
                    isInvalid={error.isError}
                    onRemoveChip={handleCloseClick}
                    inputValue={input}
                    onInputChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    placeholder={placeholder}
                    _focusWithin={focusWithinStyles}
                    inputProps={{
                        type: 'number',
                        onWheel: (event) => event.target.blur(),
                        onKeyPress: (event) => {
                            if (!NUMERIC_PATTERN.test(event.key)) {
                                event.preventDefault();
                            }
                        },
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label={exampleText}
                        ariaLabel={`${name}-tip`}
                        left="25px"
                    />
                )}
            </Stack>
            <FieldError pl={LABEL_TO_INPUT_GAP} isDrawer={false}>
                {error.message || error.duplicates}
            </FieldError>
        </FormControl>
    );
};

export default CountryCodesField;
